import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectCurrencyValPros<T> = Omit<SelectProps<T>, "options">

function SelectCurrencyVal<T>(props: SelectCurrencyValPros<T>) {
  const { t } = useTranslation();
  const { currencys } = useContext(DictContext);

  return (
    <Select
      {...props}
      options={
        currencys.map(type => ({ key: type.key, label: type.desc, value: type.desc }))
      }
      placeholder={t('shipment.plCurrency')}
    />
  )
};

export default SelectCurrencyVal;